<template>
  <v-flex
    xs12
    class="mt-4">
    <v-flex class="d-flex ml-0 pl-0">
      <h3 class="text-capitalize ml-4 font-weight-regular">
        {{ $t('All stores') }}
      </h3>
      <v-spacer />
      <v-btn
        v-if="me.root"
        class="px-0"
        @click="toggleAddNewStore"
      >
        {{ $t('Create new store') }}
      </v-btn>
    </v-flex>
    <v-layout
      wrap
      row>
      <v-flex xs12>
        <v-card
          v-if="stores && stores.length > 0"
          class="mx-4"
        >
          <v-list
            two-line
            subheader
          >
            <v-list-group
              v-for="item in stores"
              v-model="item.active"
              :key="item.code"
              no-action
            >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="primary--text">
                      {{ item.name }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <v-flex>
                <v-flex
                  xs12
                  sm6
                >
                  <store-form
                    :store="item"
                    @containErrors="containErrors"
                  />
                  <v-btn
                    :disabled="hasErrors"
                    class="mt-4"
                    @click="updateStoreItem(item)"
                  >
                    {{ $t('Update') }}
                  </v-btn>
                  <v-btn
                    v-if="me.root"
                    :disabled="stores.length <= 1"
                    class="mt-4"
                    @click="deleteStoreItem(item)"
                  >
                    {{ $t('Delete') }}
                  </v-btn>
                </v-flex>
              </v-flex>
            </v-list-group>
          </v-list>
        </v-card>
        <v-flex
          v-else
          class="mx-4 headline"
          style="color:gray;"
        >
          {{ $t('No stores to display') }}
        </v-flex>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="isAddingNewStore"
      width="700"
    >
      <store-creator
        @created="isAddingNewStore = false"
      />
    </v-dialog>
  </v-flex>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddNewStoreForm from '@/modules/Settings/components/AddNewStoreForm'
import StoreForm from '@/modules/Settings/components/StoreForm'
import StoreCreator from '@/modules/Settings/components/Stores/StoreCreator'

export default {
  name: 'StoresList',

  components: {
    StoreCreator,
    AddNewStoreForm,
    StoreForm
  },

  data () {
    return {
      isAddingNewStore: false,
      hasErrors: false,
      fetchedStores: null,
      isPanelOpen: true
    }
  },

  computed: {
    ...mapGetters(['tenancy', 'stores']),
    ...mapGetters({
      me: 'auth/me'
    })
  },

  methods: {
    ...mapActions([
      'updateStore',
      'deleteStore',
      'setStore'
    ]),

    toggleAddNewStore () {
      this.isAddingNewStore = !this.isAddingNewStore
    },

    containErrors (status) {
      this.hasErrors = status
    },

    async updateStoreItem (item) {
      const store = await this.$http
        .make('stores', {
          'id': item.id,
          'name': item.name,
          'url': item.url,
          'color': item.color.hex || item.color
        })
      store.save().then(() => {
        this.updateStore(item)
        this.$radio.$emit('item-saved', { message: 'Store updated' })
      })
    },

    async deleteStoreItem (item) {
      const store = await this.$http
        .make('stores', {
          'id': item.id
        })
      store.delete().then(() => {
        this.deleteStore(item.code)
        this.$toast.success(this.$t('Store deleted'))
        if (this.tenancy.code === item.code) {
          this.setStore(this.stores[0].code)
        }
      })
    }
  }
}
</script>
